import React from 'react';

import { Grid, Stack, Typography } from '@mui/material';

import { BackSubmitButton } from '@components/forms/currentUser/styles';
import SubmitButton from '@components/submitButton';

import useWebAuthn from './hooks/useWebAuthnForm';

const EnableWebAuthn2FA = ({ onDecline }: { onDecline: () => void }) => {
	const { registerWebAuthn2FA, isLoading } = useWebAuthn({ onDecline });

	return (
		<Stack spacing={3}>
			<Typography>Are you sure you want to enable the Web Auth 2FA method?</Typography>
			<Stack spacing={3} direction="row">
				<Grid item xs={6}>
					<BackSubmitButton fullWidth type="button" variant="contained" color="secondary" onClick={onDecline}>
						Back
					</BackSubmitButton>
				</Grid>
				<Grid item xs={6}>
					<SubmitButton disabled={isLoading} label={'Enable 2FA'} onClick={registerWebAuthn2FA} />
				</Grid>
			</Stack>
		</Stack>
	);
};

export default EnableWebAuthn2FA;
